import React, { Suspense } from 'react';
import LogRocket from 'logrocket';
import { ApolloProvider } from '@apollo/react-hooks';
import { BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';

import * as components from './components';
import Files from './components/files';

import reducers from './reducers';
import ProtectedRoute from './ProtectedRoute.jsx';
import useApolloClient from './apolloClient';
import { AppContextProvider } from './AppContext';
import ErrorBoundary from './ErrorBoundary';

import { Toaster } from 'sonner';
import './css/print.css';
import { useAuth0 } from './react-auth0-spa';

if (import.meta.env.VITE_LOGROCKET) {
  LogRocket.init(import.meta.env.VITE_LOGROCKET);
}

const store = createStore(
  combineReducers({
    ...reducers,
  }),
  {}
);

function App() {
  const { loading, getTokenSilently } = useAuth0();
  const apolloClient = useApolloClient(getTokenSilently);

  if (loading) return null;

  return (
    <ErrorBoundary>
      <Toaster richColors />
      <ApolloProvider client={apolloClient}>
        <Provider store={store}>
          <AppContextProvider>
            <BrowserRouter>
              <Suspense fallback={<div />}>
                <div>
                  <Switch>
                    <ProtectedRoute exact path="/" component={() => <Redirect to="/notices" />} />

                    {/* Notice */}
                    <ProtectedRoute
                      path={'/notice/:reference/grant/:grant/edit'}
                      component={components.NoticeGrantEditPage}
                    />

                    <ProtectedRoute path={'/notice/:reference/edit'} component={components.NoticeEditPage} />

                    <ProtectedRoute path="/notice/:reference/:page?" component={components.NoticePage} />

                    {/* Notices */}
                    <ProtectedRoute path="/notices" component={components.NoticesPage} />

                    {/* Grants */}
                    <ProtectedRoute path="/grants" component={components.Grants} />

                    {/* Working Sets */}
                    <ProtectedRoute path="/workingsets/add" component={components.WorkingSetsAddPage} />
                    <ProtectedRoute path="/workingsets" component={components.WorkingSetsPage} />

                    {/* Working Set */}
                    <ProtectedRoute path="/workingset/:name" component={components.WorkingSetPage} />

                    {/* Sources */}
                    <ProtectedRoute path="/sources/add" component={components.SourcesAddPage} />
                    <ProtectedRoute path="/sources" component={components.SourcesPage} />

                    {/* Users */}
                    <ProtectedRoute path="/users/add" component={components.UsersAddPage} />
                    <ProtectedRoute exact path="/users" component={components.UsersPage} />

                    {/* Solicitors */}
                    <ProtectedRoute exact path="/solicitors" component={components.SolicitorsPage} />
                    <ProtectedRoute path="/solicitors/add" component={components.SolicitorsAddPage} />

                    <ProtectedRoute path="/contacts" component={components.ContactsPage} />
                    <ProtectedRoute path="/library" component={components.LibraryPage} />
                    <ProtectedRoute path="/activity" component={components.ActivityPage} />
                    <ProtectedRoute path="/admin" component={components.AdminPage} />

                    <ProtectedRoute path="/files" component={Files} />
                  </Switch>
                </div>
              </Suspense>
            </BrowserRouter>
          </AppContextProvider>
        </Provider>
      </ApolloProvider>
    </ErrorBoundary>
  );
}

export default App;
